"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.MealVoucherStatus=void 0;var e;(function(t){t.NotApplicable="NOT_APPLICABLE"})(e||(exports.MealVoucherStatus=e={}));
//# sourceMappingURL=MealVoucherStatus.js.map
